import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTimecardHistoryDetails extends Layout {
    buttonJobClassification: Button;
    horizontalspacer1: HorizontalSpacer;
    labelDetails: Label;
    labelHours: Label;
    labelJobClassification: Label;
    labelP: Label;
    labelTotal: Label;
    panelDetails: Panel;
    panelHours: Panel;
    panelJobClassification: Panel;
    panelRate: Panel;
    panelTotals: Panel;
    panelUnits: Panel;
    sourceDrsTimecardHist: DataSource;
    textboxAddlTaxOverrideHours: Textbox;
    textboxDepartment: Textbox;
    textboxDrsPayeedivisionId: Textbox;
    textboxDrsPayeejobClassCodeId: Textbox;
    textboxDrsPayeeterminalId: Textbox;
    textboxDrsPayrollHistpayperiodEnd: Textbox;
    textboxDrsPayrollHistpayperiodStart: Textbox;
    textboxHolidayRate: Textbox;
    textboxHolidayTotal: Textbox;
    textboxHolidayUnits: Textbox;
    textboxOvertimeRate: Textbox;
    textboxOvertimeTotal: Textbox;
    textboxOvertimeUnits: Textbox;
    textboxPayMethod: Textbox;
    textboxPaymentFrequency: Textbox;
    textboxRegularRate: Textbox;
    textboxRegularTotal: Textbox;
    textboxRegularUnits: Textbox;
    textboxSickRate: Textbox;
    textboxSickTotal: Textbox;
    textboxSickUnits: Textbox;
    textboxVacationRate: Textbox;
    textboxVacationTotal: Textbox;
    textboxVacationUnits: Textbox;
}
